import { render, staticRenderFns } from "./CircleChart.vue?vue&type=template&id=e0129672&scoped=true&"
import script from "./circle-chart.js?vue&type=script&lang=js&"
export * from "./circle-chart.js?vue&type=script&lang=js&"
import style0 from "./circle-chart.scss?vue&type=style&index=0&id=e0129672&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0129672",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e0129672')) {
      api.createRecord('e0129672', component.options)
    } else {
      api.reload('e0129672', component.options)
    }
    module.hot.accept("./CircleChart.vue?vue&type=template&id=e0129672&scoped=true&", function () {
      api.rerender('e0129672', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/AudienceManager/Components/Charts/CircleChart/CircleChart.vue"
export default component.exports